import { render, staticRenderFns } from "./APIIntegrations.vue?vue&type=template&id=4afb783a&scoped=true"
import script from "./APIIntegrations.vue?vue&type=script&lang=js"
export * from "./APIIntegrations.vue?vue&type=script&lang=js"
import style0 from "./APIIntegrations.vue?vue&type=style&index=0&id=4afb783a&prod&lang=scss&scoped=true"
import style1 from "./APIIntegrations.vue?vue&type=style&index=1&id=4afb783a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afb783a",
  null
  
)

export default component.exports